<template>  
    <main class="home">
        <full-page :options="options" id="fullpage" ref="fullpage">
            <div v-if="blocks.length < 1" class="section active"></div>
            <component v-else
                v-for="(block, index) in blocks"
                :key="index"
                class="section"
                :class="{ 'active' : index === 0 }"
                :is="block.component"
                :data-anchor="block.name"
                :block="block" />
        </full-page>
    </main>
</template>

<script>
import Axios from 'axios'

export default {
    data() {
        return {
            home: {},
            options: {
                licenseKey: '7699933E-A53D434C-B5D8B737-7EC97A11',
                scrollOverflow: true,
                scrollBar: false,
                menu: '#menu'
            },
        }
    },

    created() {
        Axios.get(`${this.$VUE_APP_API_URL}/home`).then(res =>{
            this.home = res.data
        })
    },

    updated() {
        this.$refs.fullpage.build();
    },

    // destroyed() {
    //     this.$refs.fullpage.destroy('all')
    // },

    computed: {
        blocks() {
            if(this.home.content) {
                return this.home.content.map(block => {
                    let name = block.__component.substr(6)
                    delete block.__component
                    block.component = require(`./blocks/${name}.vue`).default
                    return block
                })
            }
            return []
        }
    }
}
</script>